import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M8 .75v30.5c-.627-.14-1.186-.3-1.658-.48C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646A12 12 0 0 1 8 .75",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M8 31.25V.75C10.152.27 13.096.026 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-2.904-.026-5.848-.271-8-.75",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16.672 10.222a6 6 0 1 0 9.94 6.631A6.668 6.668 0 0 1 13.335 16a6.66 6.66 0 0 1 3.338-5.778m6.934 2.53-.825 1.17-.08-1.43-1.368-.422 1.336-.517-.02-1.432.904 1.11 1.355-.462-.776 1.203.858 1.146z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagPak = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagPak_default = SvgFlagPak;

export { FlagPak_default as default };
